import { useState } from 'react';

import { appWithTranslation } from 'next-i18next';
import { useRouter } from 'next/router';

import { ExitIntentPopup } from '@/components/ExitIntentModal';
import PreviewMode from '@/components/PreviewMode';
import Footer from '@/components/Footer';
import Navbar from '@/components/Navbar';

import Reset from '@/styles/globalStyles';

import useDevice from '@/hooks/device';

function App({ Component, pageProps }) {
  const router = useRouter();

  const isMobile = useDevice('(max-width: 762px)');

  const [showIntentPopup, setShowIntentPopup] = useState(false);
  const { asPath } = router;

  return (
    <>
      {asPath.includes('/blog') && !isMobile && (
        <ExitIntentPopup
          goTo="https://content.cloudez.io/webinar-tech-seo-agencias-digitais?utm_campaign=blog-webinar_techseo-visitantes&utm_medium=&utm_source=blog&utm_content=&utm_term="
          show={showIntentPopup}
          setShow={setShowIntentPopup}
        />
      )}

      <Navbar />
      <Reset />
      <Component {...pageProps} />
      <Footer />
      {pageProps.preview && <PreviewMode />}
    </>
  );
}

export default appWithTranslation(App);
